export function initFeriasIndexSearch(rootEl) {
  const input = rootEl.querySelector("#busca_funcionario_ferias");
  if (!input) return { destroy() {} };

  function filter() {
    const query = input.value.toLowerCase().trim();
    rootEl.querySelectorAll("tr[id^='movimentacao_']").forEach((row) => {
      const nomeEl = row.querySelector(".font-medium.text-gray-900");
      const nome = (nomeEl?.textContent ?? "").toLowerCase();
      row.style.display = !query || nome.includes(query) ? "" : "none";
    });
  }

  input.addEventListener("input", filter);
  return { destroy() { input.removeEventListener("input", filter); } };
}
